import { Injectable } from "@angular/core";
import { AlertController, ModalController } from "@ionic/angular";
import { BobToastService } from "../shared/toast";
import { AppService } from "./app.service";
import { ServicesAroundStateService } from "./services-around-state.service";

export type NavigationPrepReason = "push" | "pusher" | "user";

@Injectable({
  providedIn: "root",
})
export class NavigationPrepService {
  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    private bobToast: BobToastService,
    private appService: AppService,
    private servicesAroundState: ServicesAroundStateService
  ) {}

  async prepareForExternalNavigation(
    reason: NavigationPrepReason = "user"
  ): Promise<void> {
    await this.bobToast.dismissAll();
    await this.dismissAllModals(reason);
    await this.dismissTopAlert();
    this.appService.resetTransientModalState();
    this.servicesAroundState.closeAllModals();
  }

  private async dismissAllModals(reason: NavigationPrepReason): Promise<void> {
    let modal = await this.modalController.getTop();
    while (modal) {
      try {
        await modal.dismiss(undefined, reason);
      } catch {
        break;
      }
      modal = await this.modalController.getTop();
    }
  }

  private async dismissTopAlert(): Promise<void> {
    try {
      const alert = await this.alertController.getTop();
      if (alert) {
        await alert.dismiss();
      }
    } catch {
      // getTop() unavailable on some Ionic versions.
    }
  }
}
